module.exports = __webpack_public_path__ + "img/deepwater-green-side.8001f28d.png";